import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useIntercom } from 'react-use-intercom'

const IntercomManager = () => {
  const { boot, update, shutdown } = useIntercom()
  const { user, isAuthenticated, isLoading } = useAuth0()
  const location = useLocation()

  useEffect(() => {
    if (isLoading) return

    if (isAuthenticated && user) {
      boot({
        email: user.email,
        userId: user.sub ?? undefined,
        name: user.name,
      })
    } else if (!isAuthenticated) {
      shutdown()
    }
  }, [isAuthenticated, isLoading, user, boot, shutdown])

  useEffect(() => {
    if (!isAuthenticated) return
    update({ lastRequestAt: Math.floor(Date.now() / 1000) })
  }, [location.pathname, isAuthenticated, update])

  return null
}

export default IntercomManager
